<template>
  <div class="loginDynamicPassPage">
    <job-header-simple :header_title="header_title"></job-header-simple>
    <van-field
      v-model="tel"
      clearable
      placeholder="请填写手机号"
      :border="input_border"
    />
    <van-field
      v-model="code"
      clearable
      placeholder="请填写动态码"
      :border="input_border"
    >
      <template slot="button">
        <van-count-down
          ref="countDown"
          :auto-start="false"
          @finish="countFinished"
          :time="time"
          format="ss"
          v-show="isOn"
          class="i-text"
        />
        <span @click="handleCode" class="i-text" v-show="!isOn"
          >发送验证码</span
        >
      </template>
    </van-field>
      <div>
        <van-checkbox v-model="isSelected" icon-size="12px" style="color: black; font-size:13px" label-disabled>已阅读并同意
          <router-link style="color: blue;font-size:13px" to="/privacy">《工蚁宝隐私权政策》</router-link>
        </van-checkbox>
      </div>
    <van-button
      type="info"
      size="large"
      class="btn"
      @click="onClickButtonSubmit"
      >{{ btn_text }}</van-button
    >
    <div class="links" v-if="!isLogin">
      <router-link to="/login">账号密码登录</router-link>
    </div>
  </div>
</template>
<script>
import { Button, Field, Toast, Icon, CountDown,Checkbox } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
import { Notify } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [CountDown.name]: CountDown,
    jobHeaderSimple,
    [Notify.name]: Notify,
    [Checkbox.name]:Checkbox,
  },
  data() {
    return {
      isSelected:false,
      header_title: this.$route.query.status == 1 ? "动态码登录" : "忘记密码",
      btn_text: this.$route.query.status == 1 ? "登 录" : "下一步",
      input_border: false,
      tel: "",
      code: "",
      time: 60 * 1000, //5秒
      isOn: false,
      token: null,
      isLogin: this.$store.getters.jwtDecode.exp,
    };
  },
  created(){
    this.getPageData()
  },
  watch:{
    tel:{
      handler:function () {
        localStorage.setItem("this.tel",JSON.stringify(this.tel))
      }
    }
  },
  methods: {
    getPageData(){
      this.tel = JSON.parse(localStorage.getItem('this.tel'));//使用getItem方法的前提是，你再自己需要的地方使用了setItem方法
    },
    onClickButtonSubmit() {
      if (!this.isSelected){
        this.$toast("请勾选协议!");
        return false;
      }
      if (this.tel == "") {
        this.$toast("手机号码不能为空");
        return false;
      }
      if (this.code == "") {
        this.$toast("验证码不能为空");
        return false;
      }

      if (this.$route.query.status == 1) {
        let parm = {
          tel: this.tel,
          password: this.code,
          token: this.token,
          type: "sms_code",
        };
        this.$store
          .dispatch("Login", parm)
          .then((res) => {
            this.loading = false;
            if (res.status == "200") {
              if (res.data.passwordFlag == "0") {
                return this.$router.push({
                  name: "setPass",
                  params: {
                    status: 1,
                    code: this.code,
                    token: this.token,
                    mobile: this.tel,
                    passwordFlag: 0,
                  },
                });
              } else {
                if (this.btn_text == "下一步") {
                  return this.$router.push({
                    name: "setPass",
                    params: { status: 0 },
                  });
                } else {
                  api.getAccountIdntityType().then((res) => {
                    this.$store.dispatch("getUserInfo");
                    if (res.data.status == "200") {
                      switch (res.data.data.identityType) {
                        // 普通灵活用工
                        case "COMMON_EMPLOYEE":
                          window.location.href = `${document.location.origin}/index.html#/home`;
                          break;
                        //个体户用工
                        case "INDIVIDUAL_BUSINESSES":
                          window.location.href = `${document.location.origin}/index1.html#/home`;
                          break;
                        //同时具有双重身份
                        case "DOUBLE_IDENTITY":
                          switch (res.data.data.lastMode){
                            // 普通灵活用工
                            case 1: 
                              window.location.href = `${document.location.origin}/index.html#/home`;
                              break;
                            //个体户用工
                            case 2:
                              window.location.href = `${document.location.origin}/index1.html#/home`;
                              break;
                            case null:
                              this.$router.push({
                                path: "/individual_choose",
                              });
                              break;
                          }
                          break;
                        default:
                          window.location.href = `${document.location.origin}/index.html#/home`;
                      }
                    }
                  });
                }
              }
            } else {
              this.$toast(res.message);
            }

            // this.showDialog = true;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        let parm = {
          username: this.tel,
          code: this.code,
          token: this.token,
        };
        api
          .forgetPassword(parm, { method: "post", subUrl: 0 })
          .then((res) => {
            if (res.data.status == "200") {
            
              if (res.data.data == "true") {
                return this.$router.push({
                  name: "setPass",
                  params: {
                    status: 0,
                    code: this.code,
                    mobile: this.tel,
                    token: this.token,
                  },
                });
              } else {
                this.$toast(res.data.message);
              }
            } else {
              this.$toast(res.data.message);
            }
          })
          .catch((error) => {
            this.$toast(error.response.data.message);
            this.loading = false;
          });
      }
    },
    handleCode() {
      if (this.tel == "") {
        this.$toast("手机号码不能为空");
        return false;
      }

      api
        .sendSmsCode({ mobile: this.tel })
        .then((res) => {
          if (res.data.status == "200") {
            this.token = res.data.data;
            this.isOn = true;
            this.$refs.countDown.start();
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((error) => {
          this.$toast(error.response.data.message);
          this.loading = false;
        });
    },
    countFinished() {
      this.isOn = false;
      this.$refs.countDown.reset();
    },
  },
  mounted: function() {
    document.getElementsByTagName("body")[0].className = "bg_f";
  },
  beforeDestroy: function() {
    document.body.removeAttribute("class", "bg_f");
  },
};
</script>

<style lang="less" scoped>
.loginDynamicPassPage {
  display: block;
  padding: 44px;

  .links {
    position: fixed;
    left: 0;
    bottom: 90px;
    width: 100%;
    text-align: center;
    a {
      font-size: 13px;
      color: @blue;
    }
  }

  .btn {
    margin-top: 60px;
  }

  .i-text {
    color: @blue;
    font-size: 12px;
  }
}
</style>
<style lang="less">
.loginDynamicPassPage {
  .van-cell {
    margin-bottom: 10px;
    border-radius: 6px;
    padding: 11px 25px;
    background: #f3f3f3;
  }
}
</style>
